module.exports = __webpack_public_path__ + "static/media/home2.e1d57f9e.jpg";